import { CONFIG } from '../config';

class PinataService {
  constructor() {
    this.apiKey = CONFIG.PINATA_API_KEY;
    this.secretKey = CONFIG.PINATA_SECRET_KEY;
    this.baseUrl = 'https://api.pinata.cloud';
  }

  async uploadFile(file, metadata = {}) {
    if (!this.apiKey || !this.secretKey) {
      throw new Error('Pinata API credentials not configured');
    }

    const formData = new FormData();
    formData.append('file', file);
    
    if (Object.keys(metadata).length > 0) {
      formData.append('pinataMetadata', JSON.stringify(metadata));
    }

    const response = await fetch(`${this.baseUrl}/pinning/pinFileToIPFS`, {
      method: 'POST',
      headers: {
        'pinata_api_key': this.apiKey,
        'pinata_secret_api_key': this.secretKey,
      },
      body: formData,
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(`Pinata upload failed: ${error}`);
    }

    const data = await response.json();
    
    if (!data.IpfsHash) {
      throw new Error('No IPFS hash returned from Pinata');
    }

    return {
      cid: data.IpfsHash,
      size: data.PinSize,
      timestamp: data.Timestamp
    };
  }

  async uploadJSON(data, metadata = {}) {
    if (!this.apiKey || !this.secretKey) {
      throw new Error('Pinata API credentials not configured');
    }

    const response = await fetch(`${this.baseUrl}/pinning/pinJSONToIPFS`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'pinata_api_key': this.apiKey,
        'pinata_secret_api_key': this.secretKey,
      },
      body: JSON.stringify({
        pinataContent: data,
        pinataMetadata: metadata
      }),
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(`Pinata JSON upload failed: ${error}`);
    }

    const result = await response.json();
    
    if (!result.IpfsHash) {
      throw new Error('No IPFS hash returned from Pinata');
    }

    return {
      cid: result.IpfsHash,
      size: result.PinSize,
      timestamp: result.Timestamp
    };
  }

  getGatewayUrl(cid) {
    return `https://gateway.pinata.cloud/ipfs/${cid}`;
  }

  async fetchFromIPFS(cid) {
    const url = this.getGatewayUrl(cid);
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch from IPFS: ${response.statusText}`);
    }
    
    return response;
  }
}

export const pinataService = new PinataService();
